<template>
  <div class="error__wrapper" @click="e => $emit('click', e)">
    <error-icon class="error__icon"/>
    <span>{{ $t('layout.error-text') }}</span>
  </div>
</template>

<script>
import ErrorIcon from '~/static/img/icons/error.svg';

export default {
  name: 'Error',
  components: { ErrorIcon },
};
</script>

<style lang="scss" scoped>
.error {
  &__wrapper {
    @extend %overlay;
    @extend %centered;
    position: absolute;
    z-index: 1;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.7);
  }

  &__icon {
    margin-right: 10px;
    fill: map-get($map: $colors, $key: error);
  }
}
</style>
